<div>
@switch ((variant() && variant().questionType) ? variant().questionType : 'CHECKBOXES') {
    @case ("CHECKBOXES") {
        <profile-checkbox [descriptorCategory]="descriptorCategory()" [projectDescriptor]="projectDescriptor()" [profileGroup]="profileGroup()" />
    }
    @case ("RADIO_BUTTONS") {
        <profile-radio-button [descriptorCategory]="descriptorCategory()" [projectDescriptor]="projectDescriptor()" [profileGroup]="profileGroup()" />
    }
    @case ("TEXT") {
        <profile-textbox [descriptorCategory]="descriptorCategory()" [projectDescriptor]="projectDescriptor()" [profileGroup]="profileGroup()" />
    }
    @case ("LONGTEXT") {
        <profile-long-textbox [descriptorCategory]="descriptorCategory()" [projectDescriptor]="projectDescriptor()" [profileGroup]="profileGroup()" />
    }
    @case ("NUMBER") {
        <profile-number [descriptorCategory]="descriptorCategory()" [projectDescriptor]="projectDescriptor()" [profileGroup]="profileGroup()" />
    }
}
</div>

